module.exports = __webpack_public_path__ + "img/muenchen_nymphenburg_2015_ref.cda877f7.jpg";